import type { AxiosInstance } from 'axios'
import type { ListResponse } from 'src/types/response'
import type { PaginationRequestParams } from 'src/types/api'
import type { WorkoutPlanCategoryType, WorkoutPlanType, WorkoutStartPageType } from 'src/types/workoutPlans'


export type WorkoutPlanParams = PaginationRequestParams & {
  category?: string | undefined,
  search?: string | undefined,
  tags?: string | undefined,
}


export class WorkoutsApi {
  api: AxiosInstance

  urls = {
    workoutPlans: () => 'workout-plans/' as const,
    workoutPlan: (slug: WorkoutPlanType['slug']) => `workout-plans/${slug}/`,
    workoutPlanCategories: () => 'workout-plans-categories/' as const,
    workoutStartPage: () => 'workout-start-page/' as const,
  }

  constructor (api: AxiosInstance) {
    this.api = api
  }

  getWorkoutPlans = async (params: WorkoutPlanParams): Promise<ListResponse<WorkoutPlanType>> => {
    const response = await this.api.get<ListResponse<WorkoutPlanType>>(
      this.urls.workoutPlans(), { params }
    )
    return response.data
  }

  getWorkoutPlan = async (slug: WorkoutPlanType['slug']): Promise<WorkoutPlanType> => {
    const response = await this.api.get<WorkoutPlanType>(this.urls.workoutPlan(slug))
    return response.data
  }

  getWorkoutPlanCategories = async (): Promise<WorkoutPlanCategoryType[]> => {
    const response = await this.api.get<WorkoutPlanCategoryType[]>(
      this.urls.workoutPlanCategories()
    )
    return response.data
  }

  getWorkoutStartPage = async (): Promise<WorkoutStartPageType | null> => {
    const response = await this.api.get<WorkoutStartPageType[]>(this.urls.workoutStartPage())
    return response.data[0] || null
  }
}
